// src/utils/mockData.js

export const getMockSensors = () => [
  { id: 'sensor-001', name: 'Warehouse Temperature Sensor', type: 'Dragino LHT65', gatewayId: 'gateway-001', lastSync: new Date(), status: 'Active' },
  { id: 'sensor-002', name: 'Office Humidity Sensor', type: 'Dragino LHT65', gatewayId: 'gateway-001', lastSync: new Date(), status: 'Inactive' },
  { id: 'sensor-003', name: 'Outdoor Weather Sensor', type: 'Dragino LHT65', gatewayId: 'gateway-002', lastSync: new Date(), status: 'Active' },
  { id: 'sensor-004', name: 'Server Room Sensor', type: 'Dragino LHT65', gatewayId: 'gateway-002', lastSync: new Date(), status: 'Inactive' },
  { id: 'sensor-005', name: 'Greenhouse Climate Sensor', type: 'Dragino LHT65', gatewayId: 'gateway-001', lastSync: new Date(), status: 'Active' },
  { id: 'sensor-006', name: 'Cold Storage Sensor', type: 'Dragino LHT65', gatewayId: 'gateway-003', lastSync: new Date(), status: 'Active' },
];

export const getMockGateways = () => [
  { id: 'gateway-001', name: 'Main Building Gateway', location: 'Main Building', status: 'Online', lastSync: new Date() },
  { id: 'gateway-002', name: 'Remote Site Gateway', location: 'Remote Site', status: 'Offline', lastSync: new Date() },
  { id: 'gateway-003', name: 'Warehouse Gateway', location: 'Warehouse', status: 'Online', lastSync: new Date() },
];

export const getMockSensorData = (sensorId) => {
  const data = [];
  const now = new Date();
  for (let i = 0; i < 30; i++) { // Generate data for 30 days
    const date = new Date(now);
    date.setDate(now.getDate() - i);

    // Generate realistic temperature and humidity values
    let temperature, humidity;
    switch (sensorId) {
      case 'sensor-001': // Warehouse Temperature Sensor
        temperature = Math.random() * 5 + 15; // 15 to 20 degrees Celsius
        humidity = Math.random() * 10 + 50; // 50 to 60% humidity
        break;
      case 'sensor-002': // Office Humidity Sensor
        temperature = Math.random() * 5 + 20; // 20 to 25 degrees Celsius
        humidity = Math.random() * 10 + 30; // 30 to 40% humidity
        break;
      case 'sensor-003': // Outdoor Weather Sensor
        temperature = Math.random() * 15 + 5; // 5 to 20 degrees Celsius
        humidity = Math.random() * 30 + 40; // 40 to 70% humidity
        break;
      case 'sensor-004': // Server Room Sensor
        temperature = Math.random() * 2 + 18; // 18 to 20 degrees Celsius
        humidity = Math.random() * 5 + 20; // 20 to 25% humidity
        break;
      case 'sensor-005': // Greenhouse Climate Sensor
        temperature = Math.random() * 10 + 20; // 20 to 30 degrees Celsius
        humidity = Math.random() * 20 + 60; // 60 to 80% humidity
        break;
      case 'sensor-006': // Cold Storage Sensor
        temperature = Math.random() * 5 + 0; // 0 to 5 degrees Celsius
        humidity = Math.random() * 10 + 70; // 70 to 80% humidity
        break;
      default:
        temperature = Math.random() * 10 + 20; // Default temperature
        humidity = Math.random() * 20 + 40; // Default humidity
    }

    data.push({
      temperature,
      humidity,
      timestamp: date,
    });
  }
  return data;
};